import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CameraDetail,
  SpeedCameraVersion,
} from "../../../api/types/CamerasAdminVM";

interface ScreenCameraSoftwareProps {
  dataDeviceDetails: CameraDetail | null;
}

interface CameraVersionGridProps {
  version: SpeedCameraVersion[] | undefined;
}

const CameraVersionGrid: FC<CameraVersionGridProps> = ({ version }) => {
  return <div className="col-span-3 text-sm leading-5 tracking-tight space-y-6">
    {version?.map((item, index) => (
      <div
        key={index}
        className="col-span-3 grid grid-cols-3 text-sm leading-5 tracking-tight"
      >
        <span className="col-span-1 font-normal">{item.region}</span>
        <span className="col-span-2 font-normal">{item.version}</span>
      </div>
    ))}
  </div>;
};

const ScreenCameraSoftware: FC<ScreenCameraSoftwareProps> = ({
  dataDeviceDetails,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix:
      "camera.dashboard.management.cameras.camera_details.tabs.software",
  });
  const [currentMapsFunctionVersion, setCurrentMapsFunctionVersion] =
    useState<String>("detail_map");

  const CameraVersionInfo = [
    {
      title: t("camera_app_version"),
      value: dataDeviceDetails?.application_version,
    },
    {
      title: t("camera_ai_version"),
      value: dataDeviceDetails?.miai_service_version,
    },
  ];

  const {
    mmf_poi_map_versions,
    mmf_detail_map_versions,
    speed_camera_versions,
  } = dataDeviceDetails?.version || {};
  return (
    <div className="col-span-9 space-y-4">
      <h1 className="font-semibold text-base leading-none align-middle col-span-9">
        {t("software_information")}
      </h1>
      <div className="bg-gray-100 col-span-9 rounded-lg p-4 mt-2 space-y-6">
        {CameraVersionInfo.map((item, index) => (
          <div
            key={index}
            className="font-semibold text-sm leading-5 tracking-tight align-middle flex flex-col gap-2"
          >
            <h1>{item.title}</h1>
            <span className="font-normal">{item.value}</span>
          </div>
        ))}
      </div>
      <h1 className="font-semibold text-base leading-none align-middle col-span-9">
        {t("mobility_maps_function_version")}
      </h1>
      <div className="bg-gray-100 col-span-9 rounded-lg p-4 mt-2">
        <div className="w-full flex font-normal text-base leading-none tracking-normal align-middle">
          <span
            onClick={() => {
              setCurrentMapsFunctionVersion("detail_map");
            }}
            className={`${currentMapsFunctionVersion === "detail_map" ? "text-accent-blue-bright" : ""} px-4 border-r border-gray-500 cursor-pointer`}
          >
            {t("detail_map")}
          </span>
          <span
            onClick={() => {
              setCurrentMapsFunctionVersion("poi_map");
            }}
            className={`${currentMapsFunctionVersion === "poi_map" ? "text-accent-blue-bright" : ""} px-4 border-r border-gray-500 cursor-pointer`}
          >
            {t("poi_map")}
          </span>
          <span
            onClick={() => {
              setCurrentMapsFunctionVersion("poi_bin");
            }}
            className={`${currentMapsFunctionVersion === "poi_bin" ? "text-accent-blue-bright" : ""} px-4 cursor-pointer`}
          >
            {t("poi_bin")}
          </span>
        </div>
        <div className="w-full grid grid-cols-3 rounded-lg bg-white p-4 mt-2 max-h-[400px] overflow-y-auto">
            <div className="col-span-3 grid grid-cols-3">
                <span className="col-span-1 font-semibold text-sm leading-5 tracking-tight align-middle">
                    {t("region")}
                </span>
                <span className="col-span-2 font-semibold text-sm leading-5 tracking-tight align-middle">
                    {t("version")}
                </span>
            </div>
            <div className="border-b border-dotted border-gray-400 col-span-9 my-2" />
                {currentMapsFunctionVersion === "detail_map" &&
                    <CameraVersionGrid version={mmf_detail_map_versions} />
                }
                {currentMapsFunctionVersion === "poi_map" &&
                    <CameraVersionGrid version={mmf_poi_map_versions} />
                }
                {currentMapsFunctionVersion === "poi_bin" &&
                    <CameraVersionGrid version={speed_camera_versions} />
                }
        </div>
      </div>
    </div>
  );
};

export default ScreenCameraSoftware;
